export default function Impressum() {
  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">Impressum</h1>
      <p>Verantwortlich: Joel Cyrille Brenner</p>
      <p>Adresse: [bitte ergänzen]</p>
      <p>Email: [bitte ergänzen]</p>
    </div>
  );
}
